export const operatingStack = [
  {
    category: 'Product strategy',
    items: ['scope clarity', 'workflow mapping', 'MVP slicing', 'launch QA'],
  },
  {
    category: 'Frontend craft',
    items: ['React', 'Tailwind', 'Nuxt', 'Framer Motion', 'responsive systems'],
  },
  {
    category: 'Backend and data',
    items: ['Xano', 'Supabase', 'Postgres', 'Firebase', 'API design'],
  },
  {
    category: 'AI and automation',
    items: ['OpenAI', 'Claude workflows', 'n8n', 'Zapier', 'Twilio', 'SendGrid'],
  },
];

export const serviceFit = [
  {
    title: 'Internal tools that replace spreadsheet gravity',
    detail: 'Dashboards, portals, approval flows, reports, and automation where teams need fewer tabs and cleaner execution.',
  },
  {
    title: 'AI-assisted workflows with human control',
    detail: 'Call review, research, scoring, summaries, and decision support built around real operator trust.',
  },
  {
    title: 'Fast product builds that still feel premium',
    detail: 'React when the experience needs polish, Xano and WeWeb when speed matters, and a practical blend when both matter.',
  },
];
